import {
  Box,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { assetIds, ThemedAsset } from "nemuru-components";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { objectTypesConfigToArray } from "../../../../../../utils/objectTypesConfigToArray";
import IconTitle from "../../../../../shared/components/IconTitle";
import MainButton from "../../../../../shared/components/MainButton";
import Text from "../../../../../shared/components/Text";
import { genderTypesConfig } from "../../config";
import { useNationalities } from "../../../../../../utils/hooks/useNationalities/useNationalities";

export default function AdditionalDataBirthInfoNieEu({ onSubmitForm, data }) {
  const { palette } = useTheme();
  const { nationalities } = useNationalities();

  const { getValues, handleSubmit, errors, control } = useForm({
    defaultValues: {
      gender: data?.gender || null,
      nationality: data?.nationality || "",
    },
  });

  return (
    <>
      <Box className="appear-anim">
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_ID_FRONT}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId="ID" />}
          subtitle={<Text tId="BIRTH_DATA" />}
        />
        <FormControl fullWidth>
          <InputLabel id="gender">
            <Text tId="GENDER" />
          </InputLabel>
          <Controller
            name="gender"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select gender",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.gender}
                >
                  {objectTypesConfigToArray(genderTypesConfig).map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.display}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.gender?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
        <FormControl fullWidth>
          <InputLabel id="nationality">
            <Text tId="NATIONALITY" />
          </InputLabel>
          <Controller
            name="nationality"
            control={control}
            rules={{
              required: {
                value: true,
                message: <Text tId={"REQUIRED_FIELD"} />,
              },
            }}
            render={(props) => (
              <>
                <Select
                  MenuProps={{
                    MenuListProps: {
                      "aria-label": "Select nationality",
                    },
                  }}
                  onChange={(e) => props.onChange(e.target.value)}
                  value={props.value}
                  error={errors.nationality}
                >
                  {nationalities.map((type) => (
                    <MenuItem key={type.value} value={type.value}>
                      {type.label}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText style={{ color: palette.error.main }}>
                  {errors.nationality?.message}
                </FormHelperText>
              </>
            )}
          />
        </FormControl>
      </Box>
      <MainButton onClick={handleSubmit(() => onSubmitForm(getValues()))} />
    </>
  );
}
